import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';

class BreadcrumbNavStore extends BaseStore {
  constructor(props = {}) {
    super();
    Object.assign(this, props);
    this.navItems = props.navItems || [];
  }

  @observable navItems = [];

  onNavClick = item => {
    if (item.href) {
      window.location.href = item.href;
      return;
    }
    this.redirect(item.path);
  };

  use() {
    super.use();
  }
}

export default BreadcrumbNavStore;
